import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Form, FormGroup } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector, getFormValues } from 'redux-form';
import Input from '../../components/Input';
import { validateRequired } from '../../helpers';

class UserPhoneVerificationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: undefined
    };
  }

  componentDidMount() {
    const { phone } = this.props;
    // set hidden fields
    this.props.change('phone', phone);
    this.setState({ phone });
    // this.setField('email', userEmail);
  }


  componentWillReceiveProps(nextProps) {
    const oldPhone = this.props.phone;
    const newPhone = nextProps.phone;

    if (oldPhone !== newPhone) {
      this.setState({ phone: newPhone });
      this.props.change('phone', newPhone);
    }
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <FormGroup>
            <Col sm={8} className="form-input">
              <Field
                component={Input}
                type="number"
                label="Verification Code"
                name="code"
                validate={validateRequired}
                className="no-increment"
              />

              <Field
                component={Input}
                type="hidden"
                name="phone"
              />

              <Button
                bsStyle="link"
                type="button"
                className="normal-link-btn"
                disabled={this.props.isSaving}
                onClick={e => this.props.resendSMS(this.state.phone)}
              >
                Resend to {this.state.phone}
              </Button>
            </Col>

            <Col sm={4}>
              <Button
                bsStyle="primary"
                type="submit"
                className="relative-padding verify-btn"
                disabled={this.props.isVerifying}
              >
                {this.props.isVerifying ? 'Verifying...' : 'Verify'}
              </Button>
            </Col>
          </FormGroup>
        </Row>

      { this.props.errorMsg &&
        <div className="alert alert-danger">{this.props.errorMsg}</div>
      }
      </Form>
    )
  }
}

// Decorate the form component
UserPhoneVerificationForm = reduxForm({
  form: 'userPhoneVerificationForm'
})(UserPhoneVerificationForm);

// Get the phone number from the other form
const mapStateToProps = state => ({
  // userPhone: formValueSelector('userRegistrationForm')(state, 'phone'),
  userEmail: formValueSelector('userRegistrationForm')(state, 'email'),
  formValues: getFormValues('userPhoneVerificationForm')(state)
});

export default connect(mapStateToProps)(UserPhoneVerificationForm);



// WEBPACK FOOTER //
// ./src/containers/users/UserPhoneVerificationForm.js